<template>
    <div class="page page-share">
        <div v-if="!userinfo.phone" class="user-info user-info1">
            <strong>您尚未登录</strong>
            <span class="login" @click="showPop('helpshow')">立即登录</span>
        </div>
        <div v-else class="user-info user-info2">
            <strong>{{ userinfo.phone }}</strong>
            <span class="logout" @click="showPop('helpshow')"></span>
        </div>
        <div class="title"></div>
        <div v-if="ishelped !== 2" class="btn btn-help" @click="helpAction"></div>
        <div v-else class="btn btn-done"></div>
        <div class="btn btn-attend" @click="attendEvent"></div>
        <!-- 助力登录 -->
        <div id="helpOtherPop" v-show="helpshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('helpshow')"></span>
                <div class="tips">
                    使用手机号登录，立即获得10行动点数
                </div>
                <h1>使用手机号验证登录，即可为您的好友助力！</h1>
                <div class="input-wrapper">
                    <div class="post">
                        {{ mypost }}
                        <select :value="post" v-model="post">
                            <option value="中国 +86">中国 +86</option>
                            <option value="美国 +1">美国 +1</option>
                            <option value="日本 +81">日本 +81</option>
                            <option value="中国香港 +852">中国香港 +852</option>
                            <option value="中国澳门 +853">中国澳门 +853</option>
                            <option value="中国台湾 +886">中国台湾 +886</option>
                            <option value="马来西亚 +60">马来西亚 +60</option>
                            <option value="澳大利亚 +61">澳大利亚 +61</option>
                            <option value="加拿大 +1">加拿大 +1</option>
                            <option value="英国 +44">英国 +44</option>
                            <option value="新加坡 +65">新加坡 +65</option>
                            <option value="德国 +49">德国 +49</option>
                            <option value="俄罗斯 +7">俄罗斯 +7</option>
                            <option value="埃及 +20">埃及 +20</option>
                            <option value="南非 +27">南非 +27</option>
                            <option value="希腊 +30">希腊 +30</option>
                            <option value="荷兰 +31">荷兰 +31</option>
                            <option value="比利时 +32">比利时 +32</option>
                            <option value="法国 +33">法国 +33</option>
                            <option value="西班牙 +34">西班牙 +34</option>
                            <option value="匈牙利 +36">匈牙利 +36</option>
                            <option value="意大利 +39">意大利 +39</option>
                            <option value="罗马尼亚 +40">罗马尼亚 +40</option>
                            <option value="瑞士 +41">瑞士 +41</option>
                            <option value="奥地利 +43">奥地利 +43</option>
                            <option value="丹麦 +45">丹麦 +45</option>
                            <option value="瑞典 +46">瑞典 +46</option>
                            <option value="挪威 +47">挪威 +47</option>
                            <option value="波兰 +48">波兰 +48</option>
                            <option value="秘鲁 +51">秘鲁 +51</option>
                            <option value="墨西哥 +52">墨西哥 +52</option>
                            <option value="古巴 +53">古巴 +53</option>
                            <option value="阿根廷 +54">阿根廷 +54</option>
                            <option value="巴西 +55">巴西 +55</option>
                            <option value="智利 +56">智利 +56</option>
                            <option value="哥伦比亚 +57">哥伦比亚 +57</option>
                            <option value="委内瑞拉 +58">委内瑞拉 +58</option>
                            <option value="印度尼西亚 +62">印度尼西亚 +62</option>
                            <option value="菲律宾 +63">菲律宾 +63</option>
                            <option value="新西兰 +64">新西兰 +64</option>
                            <option value="泰国 +66">泰国 +66</option>
                            <option value="哈萨克斯坦 +7">哈萨克斯坦 +7</option>
                            <option value="韩国 +82">韩国 +82</option>
                            <option value="越南 +84">越南 +84</option>
                            <option value="土耳其 +90">土耳其 +90</option>
                            <option value="印度 +91">印度 +91</option>
                            <option value="巴基斯坦 +92">巴基斯坦 +92</option>
                            <option value="阿富汗 +93">阿富汗 +93</option>
                            <option value="斯里兰卡 +94">斯里兰卡 +94</option>
                            <option value="缅甸 +95">缅甸 +95</option>
                            <option value="伊朗 +98">伊朗 +98</option>
                            <option value="摩洛哥 +212">摩洛哥 +212</option>
                            <option value="阿尔及利亚 +213">阿尔及利亚 +213</option>
                            <option value="突尼斯 +216">突尼斯 +216</option>
                            <option value="利比亚 +218">利比亚 +218</option>
                            <option value="冈比亚 +220">冈比亚 +220</option>
                            <option value="塞内加尔 +221">塞内加尔 +221</option>
                            <option value="马里 +223">马里 +223</option>
                            <option value="几内亚 +224">几内亚 +224</option>
                            <option value="科特迪瓦 +225">科特迪瓦 +225</option>
                            <option value="布基纳法索 +226">布基纳法索 +226</option>
                            <option value="尼日尔 +227">尼日尔 +227</option>
                            <option value="多哥 +228">多哥 +228</option>
                            <option value="贝宁 +229">贝宁 +229</option>
                            <option value="毛里求斯 +230">毛里求斯 +230</option>
                            <option value="利比里亚 +231">利比里亚 +231</option>
                            <option value="塞拉利昂 +232">塞拉利昂 +232</option>
                            <option value="加纳 +233">加纳 +233</option>
                            <option value="尼日利亚 +234">尼日利亚 +234</option>
                            <option value="乍得 +235">乍得 +235</option>
                            <option value="中非共和国 +236">中非共和国 +236</option>
                            <option value="喀麦隆 +237">喀麦隆 +237</option>
                            <option value="圣多美和普林西比 +239">圣多美和普林西比 +239</option>
                            <option value="加蓬 +241">加蓬 +241</option>
                            <option value="刚果民主共和国 +243">刚果民主共和国 +243</option>
                            <option value="安哥拉 +244">安哥拉 +244</option>
                            <option value="阿森松岛 +247">阿森松岛 +247</option>
                            <option value="塞舌尔 +248">塞舌尔 +248</option>
                            <option value="苏丹 +249">苏丹 +249</option>
                            <option value="埃塞俄比亚 +251">埃塞俄比亚 +251</option>
                            <option value="索马里 +252">索马里 +252</option>
                            <option value="吉布提 +253">吉布提 +253</option>
                            <option value="肯尼亚 +254">肯尼亚 +254</option>
                            <option value="坦桑尼亚 +255">坦桑尼亚 +255</option>
                            <option value="乌干达 +256">乌干达 +256</option>
                            <option value="布隆迪 +257">布隆迪 +257</option>
                            <option value="莫桑比克 +258">莫桑比克 +258</option>
                            <option value="赞比亚 +260">赞比亚 +260</option>
                            <option value="马达加斯加 +261">马达加斯加 +261</option>
                            <option value="津巴布韦 +263">津巴布韦 +263</option>
                            <option value="纳米比亚 +264">纳米比亚 +264</option>
                            <option value="马拉维 +265">马拉维 +265</option>
                            <option value="莱索托 +266">莱索托 +266</option>
                            <option value="博茨瓦纳 +267">博茨瓦纳 +267</option>
                            <option value="斯威士兰 +268">斯威士兰 +268</option>
                            <option value="直布罗陀 +350">直布罗陀 +350</option>
                            <option value="葡萄牙 +351">葡萄牙 +351</option>
                            <option value="卢森堡 +352">卢森堡 +352</option>
                            <option value="爱尔兰 +353">爱尔兰 +353</option>
                            <option value="冰岛 +354">冰岛 +354</option>
                            <option value="阿尔巴尼亚 +355">阿尔巴尼亚 +355</option>
                            <option value="马耳他 +356">马耳他 +356</option>
                            <option value="塞浦路斯 +357">塞浦路斯 +357</option>
                            <option value="芬兰 +358">芬兰 +358</option>
                            <option value="保加利亚 +359">保加利亚 +359</option>
                            <option value="立陶宛 +370">立陶宛 +370</option>
                            <option value="拉脱维亚 +371">拉脱维亚 +371</option>
                            <option value="爱沙尼亚 +372">爱沙尼亚 +372</option>
                            <option value="摩尔多瓦 +373">摩尔多瓦 +373</option>
                            <option value="亚美尼亚 +374">亚美尼亚 +374</option>
                            <option value="白俄罗斯 +375">白俄罗斯 +375</option>
                            <option value="安道尔共和国 +376">安道尔共和国 +376</option>
                            <option value="摩纳哥 +377">摩纳哥 +377</option>
                            <option value="圣马力诺 +378">圣马力诺 +378</option>
                            <option value="乌克兰 +380">乌克兰 +380</option>
                            <option value="斯洛文尼亚 +386">斯洛文尼亚 +386</option>
                            <option value="捷克 +420">捷克 +420</option>
                            <option value="斯洛伐克 +421">斯洛伐克 +421</option>
                            <option value="列支敦士登 +423">列支敦士登 +423</option>
                            <option value="伯利兹 +501">伯利兹 +501</option>
                            <option value="瓜地马拉 +502">瓜地马拉 +502</option>
                            <option value="萨尔瓦多 +503">萨尔瓦多 +503</option>
                            <option value="洪都拉斯 +504">洪都拉斯 +504</option>
                            <option value="尼加拉瓜 +505">尼加拉瓜 +505</option>
                            <option value="哥斯达黎加 +506">哥斯达黎加 +506</option>
                            <option value="巴拿马 +507">巴拿马 +507</option>
                            <option value="海地 +509">海地 +509</option>
                            <option value="玻利维亚 +591">玻利维亚 +591</option>
                            <option value="圭亚那 +592">圭亚那 +592</option>
                            <option value="厄瓜多尔 +593">厄瓜多尔 +593</option>
                            <option value="法属圭亚那 +594">法属圭亚那 +594</option>
                            <option value="巴拉圭 +595">巴拉圭 +595</option>
                            <option value="马提尼克 +596">马提尼克 +596</option>
                            <option value="苏里南 +597">苏里南 +597</option>
                            <option value="乌拉圭 +598">乌拉圭 +598</option>
                            <option value="文莱 +673">文莱 +673</option>
                            <option value="巴布亚新几内亚 +675">巴布亚新几内亚 +675</option>
                            <option value="汤加 +676">汤加 +676</option>
                            <option value="所罗门群岛 +677">所罗门群岛 +677</option>
                            <option value="斐济 +679">斐济 +679</option>
                            <option value="库克群岛 +682">库克群岛 +682</option>
                            <option value="法属波利尼西亚 +689">法属波利尼西亚 +689</option>
                            <option value="柬埔寨 +855">柬埔寨 +855</option>
                            <option value="老挝 +856">老挝 +856</option>
                            <option value="孟加拉国 +880">孟加拉国 +880</option>
                            <option value="马尔代夫 +960">马尔代夫 +960</option>
                            <option value="黎巴嫩 +961">黎巴嫩 +961</option>
                            <option value="约旦 +962">约旦 +962</option>
                            <option value="叙利亚 +963">叙利亚 +963</option>
                            <option value="伊拉克 +964">伊拉克 +964</option>
                            <option value="科威特 +965">科威特 +965</option>
                            <option value="沙特阿拉伯 +966">沙特阿拉伯 +966</option>
                            <option value="也门 +967">也门 +967</option>
                            <option value="阿曼 +968">阿曼 +968</option>
                            <option value="阿拉伯联合酋长国 +971">阿拉伯联合酋长国 +971</option>
                            <option value="以色列 +972">以色列 +972</option>
                            <option value="巴林 +973">巴林 +973</option>
                            <option value="卡塔尔 +974">卡塔尔 +974</option>
                            <option value="蒙古 +976">蒙古 +976</option>
                            <option value="尼泊尔 +977">尼泊尔 +977</option>
                            <option value="塔吉克斯坦 +992">塔吉克斯坦 +992</option>
                            <option value="土库曼斯坦 +993">土库曼斯坦 +993</option>
                            <option value="阿塞拜疆 +994">阿塞拜疆 +994</option>
                            <option value="格鲁吉亚 +995">格鲁吉亚 +995</option>
                            <option value="吉尔吉斯斯坦 +996">吉尔吉斯斯坦 +996</option>
                            <option value="乌兹别克斯坦 +998">乌兹别克斯坦 +998</option>
                            <option value="巴哈马 +1242">巴哈马 +1242</option>
                            <option value="巴巴多斯 +1246">巴巴多斯 +1246</option>
                            <option value="安圭拉岛 +1264">安圭拉岛 +1264</option>
                            <option value="安提瓜和巴布达 +1268">安提瓜和巴布达 +1268</option>
                            <option value="开曼群岛 +1345">开曼群岛 +1345</option>
                            <option value="百慕大群岛 +1441">百慕大群岛 +1441</option>
                            <option value="格林纳达 +1473">格林纳达 +1473</option>
                            <option value="蒙特塞拉特岛 +1664">蒙特塞拉特岛 +1664</option>
                            <option value="关岛 +1671">关岛 +1671</option>
                            <option value="圣露西亚 +1758">圣露西亚 +1758</option>
                            <option value="波多黎各 +1787">波多黎各 +1787</option>
                            <option value="多明尼加共和国 +1809">多明尼加共和国 +1809</option>
                            <option value="特立尼达和多巴哥 +1868">特立尼达和多巴哥 +1868</option>
                            <option value="牙买加 +1876">牙买加 +1876</option>
                            <option value="塞尔维亚共和国 +381">塞尔维亚共和国 +381</option>
                            <option value="毛里塔尼亚 +222">毛里塔尼亚 +222</option>
                        </select>
                        <svg width="1.2em" height="1.2em" viewBox="0 0 24 24"
                            class="ZDI ZDI--ArrowUpDown24 Select-arrow RXYxRcvJ7zVIfNZSOcHa" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M12.53 3.47a.75.75 0 0 0-1.06 0l-5 5a.75.75 0 0 0 1.06 1.06L12 5.06l4.47 4.47a.75.75 0 1 0 1.06-1.06l-5-5Zm-5 11a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06L12 18.94l-4.47-4.47Z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </div>
                    <input type="tel" v-model.trim="login.phone" placeholder="请输入手机号" />
                </div>
                <div class="input-wrapper">
                    <input type="tel" maxlength="6" v-model.trim="login.code" placeholder="请输入验证码" />
                    <div @click="sendCode" :class='login.sending ? "forbid" : ""'>
                        {{ login.sending ? `${login.num}（秒）` : `获取验证码` }}</div>
                </div>
                <div class="btn-help" @click="helpEvent"></div>
            </div>
        </div>
        <!-- 助力成功 -->
        <div id="helpSuccessPop" v-show="successshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('successshow')"></span>
                <h1>助力成功！</h1>
                <p>谢谢你的助力，TA离大奖更近一步啦！</p>
                <div class="btn-attend" @click="$router.replace('/home')"></div>
            </div>
        </div>
        <!-- 滑块验证 -->
        <MyVerify ref="validator" />
    </div>
</template>

<script>
import MyVerify from '../../components/login/verify.vue'
import { GetMyInfo, ClickHelp, SendCode, LoginHelp } from '../../api'
import mixins from '../../mixins';
export default {
    name: 'Share',
    mixins: [mixins],
    components: {
        MyVerify
    },
    computed: {
        ishelped() {
            // 0 未助力  1 已助力过非本链接   2 已助力
            let ishelped = 0;
            if (!this.userinfo.helpcode) {
                ishelped = 0;
            } else {
                if (this.userinfo.helpcode === this.helpcode) {
                    ishelped = 2;
                } else {
                    ishelped = 1;
                }
            }
            return ishelped;
        },
        mypost(){
            return this.post.split(" ")[1];
        }
    },
    data() {
        return {
            helpshow:false,
            successshow: false,
            helpcode: '',
            login: {
                phone: '',
                code: '',
                timer: null,
                num: 60,
                sending: false
            },
            userinfo: {},
            post:'中国 +86',
        }
    },
    methods: {
        attendEvent() {
            CsLib.buttonCounts('我也想寻宝');
            this.$router.replace('/game/scene');
        },
        async helpAction() {
            if (!this.userinfo.phone) {
                return this.helpshow = true;
            }
            if (this.userinfo.invitecode === this.helpcode) {
                return CsLib.alert('不能为自己助力！', 'error');
            }
            if (this.ishelped === 1) {
                return CsLib.alert('已经助力过其他人', 'error');
            }
            const res = await ClickHelp(this.helpcode);
            if (res === 3) {
                return CsLib.alert('助力失败', 'error');
            }
            CsLib.buttonCounts('为TA助力-点击助力');
            this.successshow = true;
            this.userinfo.helpcode = this.helpcode;
        },
        async helpEvent() {
            // if (!CsLib.regxTel(this.login.phone)) {
            //     return CsLib.alert('手机号码格式不正确', 'error');
            // }
            if (!this.login.phone) {
                return CsLib.alert('手机号码不能为空！', 'error');
            }
            if (!this.login.code) {
                return CsLib.alert('请输入手机验证码', 'error');
            }
            if (!/^\d+$/.test(this.login.code)) {
                return CsLib.alert('验证码格式不正确', 'error');
            }
            CsLib.buttonCounts('为TA助力-登录助力');
            // 登录直接助力
            const res = await LoginHelp(`${this.mypost}${this.login.phone}`, this.login.code, this.helpcode);
            if (res === 2) {
                this.helpshow = false;
                this.successshow = true;
                this.$set(this.userinfo, 'phone', this.login.phone);
                this.$set(this.userinfo, 'helpcode', this.helpcode);
            }
            if (res === 3) {
                this.$set(this.userinfo, 'phone', this.login.phone);
                CsLib.alert('助力失败！', 'error');
            }
            this.login.phone="";
            this.login.code="";
        },
        async getMyInfo() {
            const helpcode = CsLib.getQueryString()['helpcode'];
            this.helpcode = helpcode;
            const res = await GetMyInfo();
            if (res) {
                this.userinfo = res;
            }
        },
        async sendCode() {
            // if (!CsLib.regxTel(this.login.phone)) {
            //     return CsLib.alert('手机号码格式不正确', 'error');
            // }
            if (!this.login.phone) {
                return CsLib.alert('手机号码不能为空！', 'error');
            }
            if (this.login.sending) {
                return CsLib.alert('验证码发送中，请勿重复操作', 'error');
            }
            this.$refs.validator.refresh(async code => {
                const res = await SendCode(`${this.mypost}${this.login.phone}`, code);
                if (res == 1) {
                    this.$refs.validator.hide();
                    CsLib.alert('验证码已成功发送至手机');
                    clearInterval(this.login.timer);
                    this.login.sending = true;
                    this.login.timer = setInterval(() => {
                        if (this.login.num > 1) {
                            this.login.num--;
                        } else {
                            this.login.num = 60;
                            clearInterval(this.login.timer);
                            this.login.sending = false;
                        }
                    }, 1000);
                }
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const helpcode = CsLib.getQueryString()['helpcode'];
            if (!helpcode) {
                vm.$router.replace('/');
            }
        });
    },
    mounted() {
        this.getMyInfo();
    }
}
</script>

<style lang="scss" scoped>
.icon {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
    background-repeat: no-repeat;
    background-size: 20rem 20rem;
}

.page-share {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/4.jpg');

    .title {
        position: absolute;
        @extend .icon;
        width: 3.77rem;
        height: 7.10rem;
        background-position: 0rem -2.90rem;
        left: 0.04rem;
        top: 2.58rem;
        pointer-events: none;
        animation-name: fadeInLeft;
        animation-duration: 1s;
    }

    .user-info {
        top: 12.96rem;
        width: 100%;
        right: 0rem;
        justify-content: center;
        position: absolute;
        display: flex;
        z-index: 2;
        align-items: center;

        strong {
            color: #fff;
            font-weight: normal;
        }

        span {
            display: inline-flex;
            height: 0.42rem;
            min-width: 0.42rem;
            background-color: #000;
            color: #f4e43c;
            line-height: 0.42rem;
            border: 0.02rem solid #f4e43c;
            margin-left: 0.12rem;
            position: relative;

            &.login,
            &.bind {
                padding: 0rem 0.2rem;
            }

            &.logout {
                &::before {
                    @extend .icon;
                    position: absolute;
                    content: "";
                    width: 0.26rem;
                    height: 0.28rem;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background-position: -10.01rem 0rem;
                }
            }
        }
    }

    .btn {
        position: absolute;
        @extend .icon;

        &.btn-help {
            width: 4.82rem;
            height: 1.44rem;
            left: 1.44rem;
            top: 9.92rem;
            background-position: -5.37rem -7.74rem;
        }

        &.btn-done {
            width: 4.82rem;
            height: 1.44rem;
            left: 1.44rem;
            top: 9.92rem;
            background-position: -10.50rem -7.74rem;
        }

        &.btn-attend {
            width: 3.40rem;
            height: 1rem;
            left: 2.05rem;
            top: 11.58rem;
            background-position: -5.33rem -9.56rem;
        }
    }
}

#helpOtherPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/helpOtherPop.png');
        width: 7.02rem;
        height: 5.12rem;
        margin-left: -3.51rem;
        margin-top: -2.56rem;

        h1 {
            text-align: center;
            color: #151515;
            font-size: 0.26rem;
            padding-top: 0.84rem;
            margin-bottom: 0.36rem;
        }

        .input-wrapper {
            width: 5.5rem;
            display: flex;
            margin: 0rem auto 0.18rem auto;
            border: 0.01rem solid #151515;
            box-sizing: border-box;
            background: #fff;

            input {
                flex: 1;
                height: 0.78rem;
                border: none;
                background: none;
                outline: none;
                text-indent:1.4em;
            }

            .post {
                display: flex;
                width: 1.4rem;
                align-items: center;
                position: relative;
                box-sizing: border-box;
                justify-content: center;

                svg {
                    position: absolute;
                    right: -0.06rem;
                    z-index: 2;
                }

                select {
                    position: absolute;
                    z-index: 1;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }

                &::after {
                    content: "";
                    width: 0rem;
                    height: 50%;
                    top: 50%;
                    transform: translateY(-50%);
                    border-right: 0.01rem solid #151515;
                    position: absolute;
                    right: -0.14rem;
                }
            }

            div:not(.post) {
                @extend .icon;
                width: 2.42rem;
                text-align: center;
                line-height: 0.78rem;
                background-position: -9.30rem -9.54rem;

                &.forbid {
                    filter: grayscale(100);
                }
            }
        }

        .btn-help {
            width: 3rem;
            height: 1rem;
            margin: 0rem auto;
        }
    }
}

#helpSuccessPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/helpSuccessPop.png');
        width: 7.02rem;
        height: 3.62rem;
        margin-left: -3.51rem;
        margin-top: -1.81rem;
        text-align: center;

        h1 {
            font-size: 0.38rem;
            color: #151515;
            padding-top: 0.72rem;
        }

        p {
            color: #de381d;
            padding-top: 0.14rem;
        }

        .btn-attend {
            position: absolute;
            width: 3.4rem;
            height: 1rem;
            left: 1.84rem;
            bottom: 0.9rem;
        }
    }
}
</style>